import React from 'react';

import { useField } from 'formik';

import classNames from 'classnames';

import './index.scss';

const MutateTipPionUrl = ({ name, ...props }) => {
  const [field] = useField(name);

  return (
    <input
      {...props}
      {...field}
      className={classNames('mutate-tip-pion-url', props.className)}
      type="url"
      placeholder="URL"
    />
  );
};

export default MutateTipPionUrl;
